// ----
// JS for Related Object Links
// ----

var SCM = SCM || {};

SCM.RelatedObjectLinks = (function ($) {
    // Psssst: for the OUP site implementation, which also uses /PlatformBook/GoToRelatedObjectLink,
    //         see handleUnresolvedRelatedObjectLinks() in the OUP site client.script.js.  - JG Nov. 2020.
    const validRelatedObjectTypes = [
        'chapter', 'end-note', 'sec', 'target', 'part', 'supplementary-data', 'disp-formula','ref-list',
        'corresp','author-notes','fig','table','boxed-text','video','audio','app','fn','other'
    ];
    
    return {
        init: init,
        initContentWithinModal: initContentWithinModal
    };

    function init() {
        let selector = validRelatedObjectTypes.map(function(type)
            {
                return '.js-related-object[object-type="' + type + '"]';
            }
        ).join(', ');
        $(selector).on('click', processRelatedChapterClick);
    }
    
    function initContentWithinModal() {
        let selector = validRelatedObjectTypes.map(function(type)
            {
                return '#revealContent .js-related-object[object-type="' + type + '"]';
            }
        ).join(', ');
        
        $(selector).on('click', processRelatedChapterClick);
    }

    function processRelatedChapterClick() {
        var redirect404 = '/customerror?statuscode=404';

        var link = $(this);
        var isbn = link.attr('isbn');
        var bookId = $('.js-book-id').val();
        var legacySectionId = link.attr('legacySectionId');

        if (sectionIsOnPage(legacySectionId)) {
            window.location.hash = legacySectionId;
            return;
        }

        isbn = isbn === null || isbn === undefined ? '' : isbn.trim();
        legacySectionId = legacySectionId === null || legacySectionId === undefined ? '' : legacySectionId.trim();


        if (isbn === '') {
            window.top.location.assign(redirect404);
            return;
        }

        $.ajax({
                url: '/PlatformBook/GoToRelatedObjectLink',
                cache: true,
                dataType: 'json',
                data: {
                    isbn: isbn.toLowerCase(),
                    legacySectionId: legacySectionId.toLowerCase(),
                    currentBookId: bookId
                }
            })
            .done(function(response) {
                if (response && response.Success) {
                    window.top.location.assign(response.RedirectURL);
                } else {
                    window.top.location.assign(redirect404);
                }
            })
            .fail(function() {
                window.top.location.assign(redirect404);
            });
    }

    function sectionIsOnPage(legacySectionId) {
        var $relatedObj = $("div[name='" + legacySectionId + "']");
        return $relatedObj.length;
    }
})(jQuery);

jQuery(function () {
    SCM.RelatedObjectLinks.init();
});